import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { I18nService } from '../../core/services/i18n.service';
import { TableConfig } from '../interfaces/sps-table/table-config';

@Injectable({
  providedIn: 'root'
})
export class TableConfigService {

  constructor(private http: HttpClient,
              private i18n: I18nService) { }

  /**
   * loading table config from local resources asynchronous
   * @param configId
   * @param useLanguage
   */
  async getTableConfig(configId: string, useLanguage: boolean = true): Promise<TableConfig> {
    const endpoint: string = 'configs/table/' + (useLanguage ? this.i18n.activeLanguageKey() + '/' : '')  + configId + '.json';
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return await firstValueFrom(this.http.get<TableConfig>(endpoint, {headers}));
  }

}
